export { Chip } from "@mantine/core";
export type { ChipProps, ChipGroupProps } from "@mantine/core";
export { chipOverrides } from "./Chip.config";
